mutation CreateCharityBankAccountVerificationCall(
  $input: CreateCharityBankAccountVerificationCallInput!
) {
  createCharityBankAccountVerificationCall(input: $input) {
    verificationCall {
      id
      callDateTime
      callOutcome
      organizationName
      contactName
      contactRole
      redFlagsPresent
      redFlagsMitigationNotes
      completedByUser {
        id
        firstName
        surname
      }
    }
  }
}
